import ReportsTrends from "./Trends";

export default ReportsTrends;
